<template>
<layout-content>
  <template #toolbar>
    <period-time
      :query="query"
      :start-date-picker-options="startDatePickerOptions"
      :end-date-picker-options="endDatePickerOptions"
      :show-options="showOptions"
    >
      <site-query :sites="filterSites" :query="query" />

      <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border /> -->

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="onSearchBtnClick"
      >查询</el-button>
    </period-time>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <div style="flex:1;padding:0 12px;"></div>

        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <div style="position:relative;flex:1;display:flex;justify-content:flex-end;padding:0 12px;">
          <PassLegend />
        </div>
      </template>

      <report-data-table
        v-for="data in dataList"
        :granularity="query.granularity"
        :key="data.id"
        :current-query="currentQuery"
        :data-config="data"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
// import DataFormatter from '../../../../model/DataFormatter'
import unitConverter from '../../../../utils/unitConverter'

import LayoutContent from '../../../../components/Layout/Content'
import PeriodTime from '../../../../components/Data/PeriodTime'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import ReportDataTable from '../../02Normal/ReportDataTable'

export default {
  name: 'DataManagementMethaneAvgStatistics',
  routeInfo: {
    label: '甲烷非甲烷均值统计',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, PeriodTime, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, ReportDataTable},
  data: () => ({
    query: {
      granularity: 'day_and_night',
      isAuditCompleted: true,
      isMultipleIntegral: true
    }
  }),
  computed: {
    showOptions () {
      return ['day_and_night', 'hour', 'day', 'month', 'quarter', 'year']
    },
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY)
    ],
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    }
  },
  methods: {
    changeQueryTime (query) {
      let data = JSON.parse(JSON.stringify(query))
      delete data.dataType
      delete data.isGetInvalidData
      let {granularity, beginTime, endTime} = query
      switch (granularity) {
        case 'year':
          data.beginTime = new Date(beginTime).format('YYYY/01/01 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/12/31 23:59:59')
          break
        case 'month':
          let date = new Date(endTime)
          let year = date.getFullYear()
          let month = date.getMonth() + 1
          data.beginTime = new Date(beginTime).format('YYYY/MM/01 00:00:00')
          data.endTime = new Date(year, month, 0).format('YYYY/MM/DD 23:59:59')
          break
        case 'day':
          data.beginTime = new Date(beginTime).format('YYYY/MM/DD 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/MM/DD 23:59:59')
          break
        case 'hour':
          data.beginTime = new Date(beginTime).format('YYYY/MM/DD 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/MM/DD 23:59:59')
          break
      }

      return data
    },
    getData () {
      this.changeLoadStatus(true)
      let query = this.changeQueryTime(this.query)

      this.$api.AvgData.getOtherAvgData(query).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData () {
      let {currentQuery, tmpList} = this

      if (Object.keys(currentQuery).length === 0) {
        return
      }

      let {dimension} = this
      let otherDimension = dimension ^ 1

      let dimensionIdProps = new Array(2)
      dimensionIdProps[dimension] = 'siteId'
      dimensionIdProps[otherDimension] = 'factorId'
      let [dimensionIdProp0] = dimensionIdProps

      let dimensionIds = new Array(2)
      dimensionIds[dimension] = currentQuery.siteIds
      dimensionIds[otherDimension] = currentQuery.factorIds
      let [dimensionIds0, dimensionIds1] = dimensionIds

      let {siteFactorMap, factorSiteMap, unitProp} = this
      let dimensionObjects = new Array(2)
      dimensionObjects[dimension] = siteFactorMap
      dimensionObjects[otherDimension] = factorSiteMap
      let dimensionObjectMap = dimensionObjects[0]

      this.dataList = Object.freeze(Object.values(tmpList.reduce((map, data) => {
        let newDataConfig = map[data[dimensionIdProp0]]

        if (newDataConfig) {
          newDataConfig.dataList = data.data.map(data => newDataConfig.dimensions.reduce((newData, dimension) => {
            let dimensionId = dimension.id
            let value = data[dimensionId] ? data[dimensionId].value : '--'
            newData[dimensionId] = Number.isFinite(value) ? Number(unitConverter(value, dimension.stdUnit, dimension[unitProp], dimension.molecular).toFixed(3)) : '--'
            newData[dimensionId + 'Flag'] = data[dimensionId] ? data[dimensionId].isHaveIntegral : false
            newData[dimensionId + 'isPass'] = data[dimensionId] ? Number(data[dimensionId].isPass) : undefined
            return newData
          }, {
            dataTime: data.dataTime
          }))
        }

        return map
      }, dimensionIds0.reduce((map, dimensionId) => {
        let dimensionObject = dimensionObjectMap[dimensionId]
        let subDimensionMap = dimensionObject.map
        let seriesDimensions = dimensionIds1.reduce((list, id) => {
          let dimensionObj = subDimensionMap[id]

          if (dimensionObj) {
            list.push(dimensionObj)
          }

          return list
        }, [])

        map[dimensionId] = {
          id: dimensionId,
          name: dimensionObject.name,
          dimensions: seriesDimensions,
          unitProp
        }

        return map
      }, {}))))
    },
    setDataList (dataList) {
      this.tmpList = Object.freeze(dataList)
      this.formatData()
      this.newFormatData()
    },
    onUnitPropChange () {
      this.formatData()
      this.newFormatData()
    },
    newFormatData () {
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      this.dataList = dataList.map(el => {
        el.dataList.forEach(data => {
          let total = 0
          let flag = false
          for (let key in data) {
            if (key !== 'dataTime' && data[key] !== '--' && typeof data[key] !== 'boolean') {
              total += data[key]
            }

            if (typeof data[key] === 'boolean' && data[key]) {
              flag = true
            }
          }
          data.total = total ? total.toFixed(3) : '--'
          data.totalFlag = flag
        })

        return {...el}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/01Data-Statistical/08MethaneAvg/index.vue